var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress",style:({
  '--color': _vm.activeColor,
  '--inActiveColor': _vm.inActivecolor,
  '--activeValue': _vm.activeValue,
  '--height': _vm.height
})})
}
var staticRenderFns = []

export { render, staticRenderFns }